module.exports = __webpack_public_path__ + "static/media/howItWorks_step5.981b6210.png";